import axios from 'axios';
import config from '@/vue-caas/config/config.js';
import {
  isEmptyProcessWindowList,
  changeProcessShareFlag,
  compareTableData,
} from '@/vue-caas/utils/process';

const baseURI = config.setupApiUrl;

const aiClientStoreModule = {
  state: {
    aiClientList: [],
    aiClientSelectBoxList: [],
    aiClientDetail: {},
    aiClientId: '',
    dataSet01Source: [],
    searchBy: {},
    aiClientChange: {},
  },
  mutations: {
    SET_STORE_AI_CLIENT_LIST(state, aiClientList) {
      if (
        JSON.stringify(state.dataSet01Source) !== JSON.stringify(aiClientList) &&
        !isEmptyProcessWindowList()
      ) {
        changeProcessShareFlag('AI');
      }
      state.aiClientList = aiClientList;
      state.dataSet01Source = aiClientList;
    },
    SET_STORE_AI_CLIENT_SELECT_BOX_LIST(state, aiClientSelectBoxList) {
      state.aiClientChange = compareTableData(
        state.aiClientSelectBoxList,
        aiClientSelectBoxList,
        'aiId'
      );
      state.aiClientSelectBoxList = aiClientSelectBoxList.map((item) => {
        return {
          ...item,
          text: item.aiNm,
          value: item.aiId,
        };
      });
    },
    SET_STORE_AI_CLIENT(state, aiClientDetail) {
      state.aiClientDetail = aiClientDetail;
    },
    SET_STORE_AI_CLIENT_ID(state, id) {
      state.aiClientId = id;
      if (!isEmptyProcessWindowList()) {
        changeProcessShareFlag('AI');
      }
    },
    SET_STORE_SEARCH_AI_CLIENT(state, searchBy) {
      let datarows = state.dataSet01Source;
      state.searchBy = searchBy;
      let filterBy = state.searchBy;
      let listResult = [];
      if (filterBy != null) {
        let searchBy = filterBy.searchBy;
        let str = filterBy.str;
        if (str.trim() == '') {
          listResult = datarows;
        }
        listResult = datarows.filter((item) => {
          if (searchBy == 'all') {
            for (const prop in item) {
              if (typeof item[prop] == 'string') {
                let propValue = item[prop].toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              } else if (typeof item[prop] == 'number') {
                let propValue = item[prop].toString().toLowerCase();
                let queryValue = str.toLowerCase();
                if (propValue.includes(queryValue)) {
                  return true;
                }
              }
            }
          } else {
            if (typeof item[searchBy] == 'string') {
              let propValue = item[searchBy].toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            } else if (typeof item[searchBy] == 'number') {
              let propValue = item[searchBy].toString().toLowerCase();
              let queryValue = str.toLowerCase();
              if (propValue.includes(queryValue)) {
                return true;
              }
            }
          }

          return false;
        });
      }
      state.aiClientList = listResult;
    },
  },
  actions: {
    getAIClientList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/list', params)
        .then((response) => {
          commit('SET_STORE_AI_CLIENT_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },
    setFilterAIClient: async ({ commit }, searchBy) => {
      commit('SET_STORE_SEARCH_AI_CLIENT', searchBy);
    },
    // 2021.10.26 203728 SPKA-224 return data not save store
    getAIClientSelectBoxList: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/list', params)
        .then((response) => {
          commit('SET_STORE_AI_CLIENT_SELECT_BOX_LIST', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    getAIClientDetail: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/aiClient/dtl/${params}`, params)
        .then((response) => {
          commit('SET_STORE_AI_CLIENT', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    duplicateCheckAIClient: async ({ commit }, params) => {
      await axios
        .get(baseURI + `/aiClient/check/${params}`, params)
        .then((response) => {
          commit('SET_STORE_AI_CLIENT_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    insertAIClient: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/insert', params)
        .then((response) => {
          // alert(response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    insertAIClientFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/insert', params)
        .then((response) => {
          commit('SET_STORE_AI_CLIENT_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    editAIClient: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/update', params)
        .then((response) => {
          // alert(response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    editAIClientFromProcSetup: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/update', params)
        .then((response) => {
          // alert(response.data);
          commit('SET_STORE_AI_CLIENT_ID', response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },

    deleteAIClient: async ({ commit }, params) => {
      await axios
        .post(baseURI + '/aiClient/delete', params)
        .then((response) => {
          // alert(response.data);
        })
        .catch((ex) => {
          throw ex;
        });
    },
  },
  getters: {
    aiClientList: (state) => state.aiClientList,
    aiClientSelectBoxList: (state) => state.aiClientSelectBoxList,
    aiClientDetail: (state) => state.aiClientDetail,
    aiClientId: (state) => state.aiClientId,
    aiClientChange: (state) => state.aiClientChange,
  },
};

export default aiClientStoreModule;
